import { createAsyncThunk } from '@reduxjs/toolkit';
import { endLoading, startLoading } from '../slices/loadingSlice';
import { handleError } from '../slices/errorsSlice';
import { convertExcelToPDF } from '../api/excelApi';

// Acción para convertir el archivo Excel a PDF
export const convertExcelToPdfThunk = createAsyncThunk(
  'documents/convertExcelToPdf',
  async ({ excelFile, filename }, { getState, dispatch }) => {
    const { token } = getState().auth;

    // Inicia la carga
    dispatch(startLoading());

    try {
      // Llamamos al método que creamos previamente
      const pdfBlob = await convertExcelToPDF(token, excelFile);

      // Al recibir el PDF, descargamos el archivo
      const url = URL.createObjectURL(pdfBlob);
      const link = document.createElement('a');
      link.href = url;
      link.download = 'Visita ' + filename + '.pdf';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      // Si ocurre un error, lo manejamos
      dispatch(handleError(error));
    } finally {
      // Finalizamos la carga
      dispatch(endLoading());
    }
  }
);
